export const formatSeconds = (seconds: number | null | undefined): string => {
  if (seconds == null) return "--";
  const mins = Math.floor(seconds / 60);
  const secs = Math.round(seconds % 60);
  if (mins >= 60) {
    const hrs = Math.floor(mins / 60);
    const remainMins = mins % 60;
    return `${hrs}h ${remainMins}m`;
  }
  return mins > 0 ? `${mins}m ${secs}s` : `${secs}s`;
};

export const fmtPct = (val: number | null | undefined): string =>
  val != null ? `${val}%` : "--";

export const fmtNum = (val: number | null | undefined): string =>
  val != null ? String(val) : "--";

export const ADMIN = "/admin";
